import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

import './SingleValueAndLabelBars.css';

const SingleValueAndLabelBars = ({ sectionTitle, data, smallLabels, colors }) => (
  <div className="section-graph">
    <ViewerPrimaryColorUserStyle domStyle="color">
      <h4 className="section-title" style={{ marginBottom: '30px' }}>{sectionTitle}</h4>
    </ViewerPrimaryColorUserStyle>

    {data.map(({ label, value }) => (
      <div key={label} className="single-value-and-label-bar--container">
        <div className="single-value-and-label-bar--label" style={{ backgroundColor: colors[0] }}>
          {smallLabels
            ? <h4>{label}</h4>
            : <h3>{label}</h3>
          }
        </div>

        <div className="single-value-and-label-bar--value" style={{ backgroundColor: colors[4] }}>
          <h3>{value}</h3>
        </div>
      </div>
    ))}
  </div>
);

SingleValueAndLabelBars.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  colors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
  .isRequired,
  smallLabels: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};

export default SingleValueAndLabelBars;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/SingleValueBar/SingleValueAndLabelBars.js